import { ToastrService as Toastr } from "ngx-toastr";

export abstract class AbToastr {
  abstract toastr: Toastr
  abstract openAlertByStatus(err: any): string;
  abstract successMessage(): void;
  abstract success(title: string, message?: string, efeitoProgressBar?: boolean): void;
  abstract successWithTimeClose(title: string, message: string, efeitoProgressBar: boolean): void;
  abstract isErrorCamera(error: any): boolean;
  abstract error(error: any): void;
  abstract errorMessage(error: any): void;
  abstract warning(message: any, clear?: any): void;
  abstract warningWithTimeClose(message: any, clear?: any, efeitoProgressBar?: boolean): void;
  abstract errorWithTimeClose(error: any): void;
  abstract erroQr(title: string, message: string): void;
  abstract infoQr(title: string, message: string): void;
  abstract info(title: string, message: string): void;
  abstract infoWithTimeClose(title: string, message: string): void;
  abstract clear();
  abstract off();
  abstract on();
  abstract isOff(): boolean;
  abstract isOn(): boolean;
}
